<template>
    <!-- 对话框 -->
    <el-drawer
        title="服务人员资金流水"
        :visible.sync="show"
        :with-header="false"
        :before-close="closeDialog"
        size="1000px"
        destroy-on-close
    >
        <el-form ref="form" :model="form" label-width="80px" style="overflow-y: auto; height: 92vh; margin-top: 20px">
            <div style="width: 95%; margin: 0 auto">
                <h2>服务人员资金流水</h2>

                <div class="text">
                    <span
                        >司机名称: <span style="margin-left: 5px">{{ driver_name }}</span>
                    </span>

                    <span
                        >电话: <span class="orange" style="margin-left: 5px">{{ driver_phone }}</span>
                    </span>
                </div>

                <div class="money-box">
                    <div>
                        <span>保证金:</span>
                        <span class="money orange">{{ form.bond }} 元</span>
                    </div>

                    <div>
                        <span>余额:</span>
                        <span class="money orange">{{ form.balance }} 元</span>
                    </div>

                    <div>
                        <span>提现中:</span>
                        <span class="money orange">{{ form.cashing }} 元</span>
                    </div>

                    <div>
                        <span>已提现:</span>
                        <span class="money orange">{{ form.cash }} 元</span>
                    </div>

                    <div>
                        <span>已冻结:</span>
                        <span class="money orange">{{ form.frozen }} 元</span>
                    </div>

                    <div>
                        <span>服务费:</span>
                        <span class="money orange">{{ form.insurance }} 元</span>
                    </div>
                    <!-- <div>
                        <span>连单奖励金:</span>
                        <span class="money orange">{{ form.connect }} 元</span>
                    </div> -->
                </div>

                <el-form-item label="操作方式:" label-width="120px">
                    <el-radio-group v-model="submit_data.operation">
                        <el-radio-button label="bond">保证金</el-radio-button>
                        <el-radio-button label="balance">余额</el-radio-button>
                        <el-radio-button label="cash">已提现</el-radio-button>
                        <el-radio-button label="frozen">已冻结</el-radio-button>
                        <el-radio-button label="insurance">服务费</el-radio-button>
                    </el-radio-group>
                </el-form-item>

                <el-form-item label="模式:" label-width="120px">
                    <el-radio-group v-model="submit_data.mode">
                        <el-radio-button label="add">+</el-radio-button>
                        <el-radio-button label="sub">-</el-radio-button>
                    </el-radio-group>
                </el-form-item>

                <el-form-item label="金额:" label-width="120px">
                    <el-input
                        v-model="submit_data.amount"
                        :placeholder="submit_rules.amount.placeholder"
                        style="width: 100px; margin-right: 5px"
                    >
                    </el-input
                    >元
                </el-form-item>

                <el-form-item label="备注:" label-width="120px">
                    <el-input v-model="submit_data.remark" type="textarea" style="width: 300px; margin-right: 5px"> </el-input>
                </el-form-item>

                <div style="display: flex; padding-left: 120px; box-sizing: border-box">
                    <el-button type="primary" @click="walletSubmit">充值</el-button>
                </div>

                <!--  为解决element ui中抽屉打开日期选择器自动获取焦点bug      -->
                <el-button style="opacity: 0; cursor: auto"></el-button>
                <!--  为解决element ui中抽屉打开日期选择器自动获取焦点bug      -->

                <p class="capital-title">资金流水记录</p>

                <el-date-picker
                    v-model="search_time"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    align="right"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    @change="timeChange"
                    style="margin-bottom: 20px; margin-right: 20px"
                >
                </el-date-picker>

                <el-button @click="recordInit">搜索</el-button>
                <el-button :icon="!progress_show ? 'el-icon-setting' : 'el-icon-loading'" @click="toExport" :disabled="progress_show">{{
                    progress_show ? '正在导出...' : '导出'
                }}</el-button>
                <div style="width: 500px; margin: 10px auto" v-if="progress_show">
                    <el-progress :percentage="progress_data"></el-progress>
                    <i class="el-icon-loading"></i>
                    正在导出...
                </div>
                <!-- 表格 -->
                <el-table :data="tableData" height="80vh" ref="multipleTable" header-cell-class-name="table-header">
                    <el-table-column type="expand">
                        <template slot-scope="props">
                            <el-form label-position="left" inline class="demo-table-expand">
                                <div>
                                    <el-form-item label="对应表:">
                                        <span>{{ props.row.table_name }}</span>
                                    </el-form-item>
                                </div>

                                <div>
                                    <el-form-item label="相关编号:">
                                        <span>{{ props.row.record_code }}</span>
                                    </el-form-item>
                                </div>
                                <div>
                                    <el-form-item label="备注:">
                                        <span>{{ props.row.remark }}</span>
                                    </el-form-item>
                                </div>
                            </el-form>
                        </template>
                    </el-table-column>

                    <el-table-column prop="operation_name" label="账户操作"> </el-table-column>

                    <el-table-column prop="amount" label="金额"> </el-table-column>

                    <el-table-column prop="name" label="订单模式"> </el-table-column>

                    <el-table-column prop="description" label="描述"> </el-table-column>

                    <el-table-column prop="surplus" label="结算后余额"> </el-table-column>

                    <el-table-column prop="date_time" label="创建时间"> </el-table-column>

                    <el-table-column prop="mode_name" label="账本模式"> </el-table-column>
                </el-table>

                <!-- 分页组件 -->
                <div style="text-align: right">
                    <el-pagination layout="prev, pager, next" :total="result_data_children.count" @current-change="pages_function">
                    </el-pagination>
                </div>
            </div>
        </el-form>
    </el-drawer>
</template>

<script>
var _this;

import bus from '../../common/bus.js';
export default {
    props: {
        isShow: Boolean,
        data: '',
        driverName: '',
        driverPhone: ''
    },

    components: {},
    watch: {
        isShow(newData, oldData) {
            _this.show = true;

            progress_show: false;
            _this.driver_name = _this.driverName;

            _this.driver_phone = _this.driverPhone;

            _this.submit_data.driver_code = _this.data;

            _this.walletInit(); //钱包信息，保证金，余额，服务费等信息

            _this.search_data_children.driver_code = _this.data;
            _this.search_data_export.driver_code = _this.data;
            _this.initDefaultDate();
        }
    },
    data() {
        return {
            show: false,

            search_time: '',

            // 司机名称
            driver_name: '',

            //司机电话
            driver_phone: '',

            // 表单数据
            form: {
                bond: '0.00',
                balance: '0.00',
                cash: '0.00',
                cashing: '0.00',
                frozen: '0.00',
                insurance: '0.00',
                connect: '0.00'
            },

            tableData: [],

            excelData: [],

            excelHead: [],

            progress_show: false,
            progress_data: 0,

            //翻页数据
            search_data_children: {
                page: 1,
                limit: 10,
                driver_code: '',
                fixed_time: ''
            },
            search_data_export: {
                page: 1,
                limit: 50,
                driver_code: '',
                fixed_time: ''
            },

            result_data_children: {
                count: 0
            },
            search_rules_children: {
                page: {
                    placeholder: '页码',
                    rules: {
                        required: true,
                        message: '页码需要大于0',
                        regulation: 'gt',
                        rulesData: 0
                    }
                },
                limit: {
                    placeholder: '每页个数',
                    rules: {
                        required: true,
                        message: '每页个数需在1-51之内',
                        regulation: 'between',
                        rulesData: [1, 51]
                    }
                }
            },

            // 表单提交数据
            submit_data: {
                driver_code: '',
                mode: '',
                operation: '',
                amount: '',
                remark: ''
            },

            submit_rules: {
                mode: {
                    placeholder: '模式',
                    rules: {
                        required: true,
                        message: '未选择模式',
                        regulation: 'gt_str',
                        rulesData: 0
                    }
                },
                operation: {
                    placeholder: '操作方式',
                    rules: {
                        required: true,
                        message: '未选择操作模式',
                        regulation: 'gt_str',
                        rulesData: 0
                    }
                },
                amount: {
                    placeholder: '请输入金额',
                    rules: {
                        required: true,
                        message: '金额需为1-999999的数字',
                        regulation: 'egt',
                        rulesData: 0
                    }
                }
            }
        };
    },
    created() {
        _this = this;

    },
    methods: {
        initDefaultDate() {
            const now = new Date();
            const end = new Date(now); // 今天

            const start = new Date(now);
            start.setMonth(start.getMonth() - 1); // 上个月同一天

            // 处理边缘情况：例如今天是 3 月 31 日，上一个月是 2 月，2 月没有 31 号
            // setMonth 会自动调整到下个月初，我们需要确保它确实是"一个月前"的逻辑
            // 如果只需要粗略的"上个月今日"，上面的 setMonth 通常够用。
            // 如果需要严格保证日期存在（如 2 月 28 日），可以做额外判断，但通常业务场景 setMonth 即可。

            // 格式化为 'yyyy-MM-dd HH:mm:ss' (因为 value-format 设置了)
            const formatDate = (date) => {
                const y = date.getFullYear();
                const m = String(date.getMonth() + 1).padStart(2, '0');
                const d = String(date.getDate()).padStart(2, '0');
                const hours = String(date.getHours()).padStart(2, '0');
                const minutes = String(date.getMinutes()).padStart(2, '0');
                const seconds = String(date.getSeconds()).padStart(2, '0');
                return `${y}-${m}-${d} ${hours}:${minutes}:${seconds}`;
            };
            const formatDate1 = (date) => {
                const y = date.getFullYear();
                const m = String(date.getMonth() + 1).padStart(2, '0');
                const d = String(date.getDate()).padStart(2, '0');
                return `${y}-${m}-${d} 00:00:00`;
            };
            this.search_time = [formatDate1(start), formatDate(end)];
            this.search_data_children.fixed_time = JSON.stringify(['between'].concat(this.search_time));
            this.search_data_export.fixed_time = JSON.stringify(['between'].concat(this.search_time));
            this.recordInit(); //列表 搜索按钮绑定方法
        },

        toExport() {
            _this.search_data_export.page = 1;
            _this.getExcelData();
        },
        // 导出excel方法
        exportData() {
            const { export_json_to_excel } = require('@/vendor/Export2Excel');
            const tHeader = ['账户操作', '金额', '订单模式', '描述', '结算后余额', '创建时间', '账本模式'];
            const filterVal = ['operation', 'amount', 'order_mode', 'description', 'surplus', 'time', 'mode'];
            const list = this.excelData;
            const data = this.formatJson(filterVal, list);
            export_json_to_excel(tHeader, data, 'fileName');
        },

        formatJson(filterVal, jsonData) {
            return jsonData.map((v) => filterVal.map((j) => v[j]));
        },

        getExcelData() {
            _this
                .$post('/driver/driverRecordLists', _this.search_data_export)
                .then((res) => {
                    _this.progress_show = true;

                    if (this.show) {
                        // 导出excel的空数组中添加数据
                        for (let i = 0; i < res.data.length; i++) {
                            _this.excelData.push({
                                operation: res.data[i].operation_name,
                                amount: res.data[i].amount,
                                order_mode: res.data[i].name,
                                description: res.data[i].description,
                                surplus: res.data[i].surplus,
                                time: res.data[i].date_time,
                                mode: res.data[i].mode_name
                            });
                            console.log(111);
                        }


                        if (_this.search_data_export.page * _this.search_data_export.limit < res.count) {
                            _this.search_data_export.page = _this.search_data_export.page + 1;
                            _this.progress_data = Math.floor(
                                ((_this.search_data_export.page * _this.search_data_export.limit) / res.count) * 100
                            );

                            _this.getExcelData();
                        } else {
                            // console.log(_this.excelData);

                            // 将数据导出execl
                            _this.exportData();

                            _this.search_data_export.page = 1;

                            // 清空数据
                            _this.excelData = [];

                            _this.progress_show = false;
                            _this.progress_data = 0;
                        }
                    } else {
                        _this.progress_show = false;
                        _this.progress_data = 0;
                    }
                })
                .catch((err) => {});
        },

        walletSubmit() {
            _this
                .$post('/driver/editDriverWallet', _this.submit_data, _this.submit_rules)
                .then((res) => {
                    _this.$message.success({
                        message: '更改成功',
                        duration: 1500
                    });

                    // 重新获取钱包信息
                    _this.walletInit();

                    _this.recordInit();
                    _this.$emit('onSubmit');
                    _this.closeDialog();
                })
                .catch((err) => {});
        },

        timeChange(val) {
            console.log(val);
            if (val != null) {
                _this.search_data_children.fixed_time = JSON.stringify(['between'].concat(val));
                _this.search_data_export.fixed_time = JSON.stringify(['between'].concat(val));
            } else {
                _this.search_data_export.fixed_time = '';
                _this.search_data_children.fixed_time = '';
            }
        },

        // 获取账单信息
        recordInit() {
            console.log(_this.search_time);

            _this
                .$post('/driver/driverRecordLists', _this.search_data_children, _this.search_rules_children)
                .then((res) => {
                    // 将获取到的数据赋值

                    _this.tableData = res.data;
                    _this.result_data_children = res;
                    console.log(_this.result_data_children.count, '====================');
                })
                .catch((err) => {});
        },

        //翻页组件的回调
        pages_function(val) {
            _this.search_data_children.page = val;

            //初始化列表
            _this.recordInit();
        },

        // 获取钱包信息
        walletInit() {
            _this
                .$post('/driver/getDriverWallet', {
                    driver_code: _this.submit_data.driver_code
                })
                .then((res) => {
                    // 将获取到的数据赋值
                    _this.form.bond = res.data.bond;
                    _this.form.balance = res.data.balance;
                    _this.form.cash = res.data.cash;
                    _this.form.frozen = res.data.frozen;
                    _this.form.cashing = res.data.cashing;
                    _this.form.insurance = res.data.insurance;
                    _this.form.connect = res.data.connect;
                })
                .catch((err) => {});
        },

        // 关闭方法
        closeDialog() {
            _this.show = false;

            _this.result_data_children = {
                count: 0
            };

            _this.search_data_children = {
                page: 1,
                limit: 10,
                driver_code: '',
                fixed_time: ''
            };
            _this.search_data_export = {
                page: 1,
                limit: 50,
                driver_code: '',
                fixed_time: ''
            };

            _this.submit_data = {
                driver_code: '',
                mode: '',
                operation: '',
                amount: '',
                remark: ''
            };
        }
    }
};
</script>

<style scoped>
.form-box {
    padding: 20px;
    box-sizing: border-box;
    margin-right: 0;
    width: 100%;
}

.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}

.avatar {
    width: 178px;
    height: 178px;
    display: block;
}

.el-form-second {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
}

.avatar-uploader {
    width: 100px;
    height: 100px;
}

.capital-title {
    border-bottom: 1px solid rgb(238, 238, 238);
    padding-bottom: 10px;
    margin-bottom: 10px;
}

h2 {
    font-family: Microsoft YaHei;
    font-weight: 600;
    line-height: 21px;
    color: #222;
    font-size: 18px;
    margin-bottom: 20px;
}

.text {
    border-bottom: 1px solid rgb(238, 238, 238);
    padding-bottom: 10px;
    margin-bottom: 10px;
}

.text > span {
    margin-right: 10px;
}
.money-box {
    display: flex;
    justify-content: space-around;
    margin-bottom: 20px;
}
.money {
    margin-left: 5px;
}
.orange {
    color: rgb(255, 149, 11);
    font-weight: 600;
}
</style>
<style>
.edit-driver .el-tabs__item.is-top.is-active {
    border: 0 !important;
}
.el-date-range-picker__time-header {
    display: block;
}
</style>
